import { c as _c } from "react/compiler-runtime";
interface UrologyIconProps {
  size?: number;
  className?: string;
}
const UrologyIcon = t0 => {
  const $ = _c(11);
  const {
    size: t1,
    className: t2
  } = t0;
  const size = t1 === undefined ? 18 : t1;
  const className = t2 === undefined ? "" : t2;
  const t3 = `dynamic-size ${className}`;
  let t4;
  if ($[0] !== size) {
    t4 = {
      "--width": size,
      "--height": size
    };
    $[0] = size;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = t4 as React.CSSProperties;
  let t10;
  let t11;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <path d="M9.23272 6.83857C10.2853 7.90082 9.8322 9.67439 9.30746 10.7917C9.1502 11.1253 9.20314 11.5314 9.36663 11.8618C10.2713 13.6842 9.7668 17.8152 6.55763 17.2077C2.32545 16.4051 2.76767 11.3472 3.65677 8.64204C4.54898 5.93684 7.67251 5.26014 9.23272 6.83857Z" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />;
    t7 = <path d="M18.5114 6.83857C17.4588 7.90082 17.9119 9.67439 18.4367 10.7917C18.5939 11.1253 18.541 11.5314 18.3775 11.8618C17.4728 13.6842 17.9773 17.8152 21.1865 17.2077C25.4187 16.4051 24.9765 11.3472 24.0874 8.64204C23.1952 5.93684 20.0716 5.26014 18.5114 6.83857Z" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />;
    t8 = <path d="M7.23166 8.50391C6.46167 9.28211 6.71594 10.6811 7.74379 11.0955" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />;
    t9 = <path d="M20.5125 8.50391C21.2825 9.28211 21.0282 10.6811 20.0004 11.0955" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />;
    t10 = <path d="M5.54541 12.9838C5.95834 12.1491 7.27973 10.6049 9.2618 11.1057C11.7394 11.7317 13.5976 14.8618 11.12 22.9999" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />;
    t11 = <path d="M22.2 12.9838C21.787 12.1491 20.4656 10.6049 18.4836 11.1057C16.006 11.7317 14.1478 14.8618 16.6254 22.9999" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t10;
    $[3] = t11;
    $[4] = t6;
    $[5] = t7;
    $[6] = t8;
    $[7] = t9;
  } else {
    t10 = $[2];
    t11 = $[3];
    t6 = $[4];
    t7 = $[5];
    t8 = $[6];
    t9 = $[7];
  }
  let t12;
  if ($[8] !== t3 || $[9] !== t5) {
    t12 = <svg className={t3} style={t5} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="none">{t6}{t7}{t8}{t9}{t10}{t11}</svg>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t12;
  } else {
    t12 = $[10];
  }
  return t12;
};
export default UrologyIcon;